import gql from 'graphql-tag';

export const ActionFlow = gql`
mutation createActionFlow($input:ActionFlowInput)
 {
    createActionFlow(input:$input) {
        configObjectId
        
        name
        configObjectType
        createdBy
        isDeleted
        itemDescription
        insert_ts
        projectId
        updatedBy
        update_ts
        deletionDate
        privileges {
            privilegeType
            roleId
            isDeleted
        }
        parentRelations {
            parentItemId
            relationType
            isDeleted
          }
        childRelations {
            childItemId
            relationType
            isDeleted
          } 
    }
}
`;